module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-settings/147assets/fonts/a0ca942271702deaff1acd390db1db07.svg";


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-sass/assets/fonts/bootstrap/glyphicons-halflings-regular.svg
// module id = 759
// module chunks = 4